import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ListService } from 'beyond-util';

import { UtilServiceClient } from './util.service';
import { BackendService } from './backend.service';
import { FormCode } from '../enums/form-code.enum';
import { FormName } from '../enums/form-name.enum';
import { EndpointTypes } from '../enums/enpoint-types.enum';

@Injectable()
export class EnumService {
  private _vrsteKorekcija: any[];
  private _tipoviUgovora: any[];
  private _naciniObracunaZaTipUgovora: any = {};
  private _naciniPlacanja: any[];
  private _vrstaUsluge: any[];
  private _statusiUgovora: any[];
  private _vrsteSpota: any[];
  private _vrsteZabrane: any[];
  private _vrsteZabraneZaSpotId: any = {};
  private _stanjaSpota: any[];
  private _stanjaSpotaZaSpotId: any = {};
  private _uloge: any[];
  private _valuteUgo: any[];
  private _valuteKurs: any[];
  private _banke: any[];
  private _programi: any[];
  private _naciniEmitovanja: any[];
  private _ucestalosti: any[];
  private _mestaTroska: any[];
  private _vrsteMedija: any[];
  private _tipoviPodugovora: any[];
  private _medijumi: any[];

  public _korekcijeUgovor: any[];
  public _korekcijePodugovor: any[];

  private _potpisanUgovorId: Number;
  private _aneksiranUgovorId: Number;
  public _vrstaKlijenta: any[];

  private tipUgovoraSwitched: Subject<any> = new Subject<any>();
  public tipUgovoraSwtiched$ = this.tipUgovoraSwitched.asObservable();

  private tipUgovoraPugSwitched: Subject<any> = new Subject<any>();
  public tipUgovoraPugSwtiched$ = this.tipUgovoraPugSwitched.asObservable();

  private _tipoviUgovoraSubject: Subject<any> = new Subject<any>();
  public tipoviUgovora$ = this._tipoviUgovoraSubject.asObservable();

  private _vrsteSpotaSubject: Subject<any> = new Subject<any>();
  public vrsteSpota$ = this._vrsteSpotaSubject.asObservable();

  private _frameRates = [
    {
      Id: 24,
      Naziv: 'film 24',
    },
    {
      Id: 29.97,
      Naziv: 'NTSC 29.97',
    },
    {
      Id: 23.98,
      Naziv: 'NTSC_Film 23.98',
    },
    {
      Id: 59.94,
      Naziv: 'NTSC_HD 59.94',
    },
    {
      Id: 25,
      Naziv: 'PAL 25',
    },
    {
      Id: 50,
      Naziv: 'PAL_HD 50',
    },
    {
      Id: 30,
      Naziv: 'web 30',
    },
    {
      Id: 60,
      Naziv: 'high 60',
    },
  ];
  private _allNacinObracuna: any[];

  get programi() {
    return this._programi;
  }

  get vrsteMedija() {
    return this._vrsteMedija;
  }

  get tipoviUgovora() {
    return this._tipoviUgovora;
  }

  get tipoviPodugovora() {
    return this._tipoviPodugovora;
  }

  get potpisanUgovorId(): Number {
    return this._potpisanUgovorId;
  }

  get aneksiranUgovorId(): Number {
    return this._aneksiranUgovorId;
  }

  get naciniObracunaZaTipUgovora() {
    return this._naciniObracunaZaTipUgovora;
  }

  get valuteUgo() {
    return this._valuteUgo;
  }

  get vrsteSpota() {
    return this._vrsteSpota;
  }

  constructor(
    private _listService: ListService,
    private _utilService: UtilServiceClient,
    private _backendService: BackendService
  ) {}

  registerEnum(data: any, enumName: string, label?: string) {
    this._listService.registerEnum(
      enumName,
      this._utilService.parseEnum(data, label)
    );
  }

  getResponseData(response: any) {
    return response.ServiceData.Data && response.ServiceData.Data.length
      ? response.ServiceData.Data
      : response.ServiceData && response.ServiceData.length
      ? response.ServiceData
      : [];
  }

  enumExists(collection: any[]): boolean {
    return !!(collection && collection.length);
  }

  filterNacinObracuna(serviceData, tipUgovoraId) {
    return serviceData.filter(no => no.TipUgovoraId === tipUgovoraId);
  }

  fetchUloge() {
    this._backendService
      .fetchSettings(
        FormCode.MSKOR_ULO,
        FormName.AdministracijaKorisnika,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._uloge = this.getResponseData(response);

        this.registerEnum(this._uloge, 'MSKOR_KOR_UlogaEnum');
        this.registerEnum(this._uloge, 'MSKOR_ULO_NazivEnum');
      });
  }

  registerPrimenaKorekcije() {
    const primenaKorekcije = [
      {
        Id: 0,
        Naziv: 'Ugovor',
      },
      {
        Id: 1,
        Naziv: 'Podugovor',
      },
      {
        Id: 2,
        Naziv: 'Emisija',
      },
    ];

    this.registerEnum(primenaKorekcije, 'MSCEN_KOR_PrimenaTipaEnum');
  }

  registerZeljenePozicije() {
    const zp = [
      {
        Id: 'Prvi',
        Naziv: 'Prvi',
      },
      {
        Id: 'Drugi',
        Naziv: 'Drugi',
      },
      {
        Id: 'Poslednji',
        Naziv: 'Poslednji',
      },
      {
        Id: 'Pretposlednji',
        Naziv: 'Pretposlednji',
      },
      {
        Id: 'Pre špice',
        Naziv: 'Pre špice',
      },
      {
        Id: 'Posle špice',
        Naziv: 'Posle špice',
      },
    ];

    this.registerEnum(zp, 'MSUGO_KOR_PozicijaEnum');
    this.registerEnum(zp, 'MSUGO_SPO_ZeljenaPozicijaEnum');
    this.registerEnum(zp, 'SpotZeljenaPozicijaEnum');
  }

  fetchTipKorekcija(isUgovor?: boolean) {
    if (
      (isUgovor && this.enumExists(this._korekcijeUgovor)) ||
      (!isUgovor && this.enumExists(this._korekcijePodugovor))
    ) {
      return;
    }

    const filter = isUgovor
      ? '?orderDirection=rbr&primenaTipa=Ugovor'
      : '?orderDirection=rbr&primenaTipa=Podugovor';

    this._backendService
      .fetchSettings(
        FormCode.MSCEN_KOR,
        FormName.PregledKorekcija,
        EndpointTypes.AllEntities,
        filter
      )
      .toPromise()
      .then(res => {
        if (isUgovor) {
          this._korekcijeUgovor = this.getResponseData(res);
          const index = this._korekcijeUgovor.indexOf(
            this._korekcijeUgovor.find(
              k => k.Naziv === 'Uvećanje za poziciju u bloku'
            )
          );
          this._korekcijeUgovor.splice(index, 1);
          this._korekcijeUgovor = this._korekcijeUgovor.filter(
            x => x.Sifra !== 'U_PB' || x.Sifra !== 'U_KB'
          );
          this.registerEnum(
            this._korekcijeUgovor,
            'MSUGO_KOR_TipKorekcijeIdEnum'
          );
        } else {
          this._korekcijePodugovor = this.getResponseData(res);
          this._korekcijePodugovor = this._korekcijePodugovor.filter(
            x => x.Sifra !== 'U_KB'
          );
          this.registerEnum(
            this._korekcijePodugovor,
            'MSUGO_PUGKOR_TipKorekcijeIdEnum'
          );
        }
      });
  }

  fetchVrstaSpota(refreshList: boolean = false) {
    if (this.enumExists(this._vrsteSpota) && !refreshList) {
      this._vrsteSpotaSubject.next(this._vrsteSpota);

      return;
    }
    this._backendService
      .fetchSettings(
        FormCode.MSSPO_VRSP,
        FormName.PregledSpotova,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(data => {
        this._vrsteSpota = this.getResponseData(data);
        this.registerEnum(this._vrsteSpota, 'MSUGO_SPO_VrstaSpotaIdEnum');
        this.registerEnum(this._vrsteSpota, 'MSSPO_SPO_VrstaSpotaIdEnum');
        this._vrsteSpotaSubject.next(this._vrsteSpota);
      });
  }

  fetchMedijumi(refreshList: boolean = false) {
    if (this.enumExists(this._medijumi) && !refreshList) {
      return;
    }
    this._backendService
      .fetchSettings(
        FormCode.MSSPO_MED,
        FormName.PregledSpotova,
        EndpointTypes.AllEntities,
        '?nedefinisano=True'
      )
      .toPromise()
      .then(data => {
        this._medijumi = this.getResponseData(data);
        this.registerEnum(this._medijumi, 'MSSPO_VRSP_MedijumIdEnum');
      });
  }

  fetchStanjeSpota() {
    if (this.enumExists(this._stanjaSpota)) {
      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSSPO_STSP,
        FormName.PregledSpotova,
        EndpointTypes.AllEntities,
        ''
      )
      .toPromise()
      .then(response => {
        this._stanjaSpota = this.getResponseData(response);
        this.registerEnum(this._stanjaSpota, 'MSSPO_SPO_StanjeSpotaIdEnum');
      });
  }

  fetchStanjeSpotaZaSpotId(spotId: any) {
    if (this.enumExists(this._stanjaSpotaZaSpotId[spotId])) {
      this.registerEnum(
        this._stanjaSpotaZaSpotId[spotId],
        'MSSPO_SPO_StanjeSpotaIdEnum'
      );

      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSSPO_STSP,
        FormName.PregledSpotova,
        EndpointTypes.AllEntities,
        '',
        spotId
      )
      .toPromise()
      .then(response => {
        this._stanjaSpotaZaSpotId[spotId] = this.getResponseData(response);

        this.registerEnum(
          this._stanjaSpotaZaSpotId[spotId],
          'MSSPO_SPO_StanjeSpotaIdEnum'
        );
      });
  }

  fetchVrstaZabraneZaSpotId(spotId: any) {
    if (this.enumExists(this._vrsteZabraneZaSpotId[spotId])) {
      this.registerEnum(
        this._vrsteZabraneZaSpotId[spotId],
        'MSSPO_VRZA_NazivEnum'
      );

      this.registerEnum(
        this._vrsteZabraneZaSpotId[spotId],
        'MSSPO_SPO_VrstaZabraneIdEnum'
      );

      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSSPO_VRZA,
        FormName.PregledSpotova,
        EndpointTypes.AllEntities,
        '',
        spotId
      )
      .toPromise()
      .then(response => {
        this._vrsteZabraneZaSpotId[spotId] = this.getResponseData(response);

        this.registerEnum(
          this._vrsteZabraneZaSpotId[spotId],
          'MSSPO_VRZA_NazivEnum'
        );

        this.registerEnum(
          this._vrsteZabraneZaSpotId[spotId],
          'MSSPO_SPO_VrstaZabraneIdEnum'
        );
      });
  }

  fetchVrstaZabrane() {
    if (this.enumExists(this._vrsteZabrane)) {
      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSSPO_VRZA,
        FormName.PregledSpotova,
        EndpointTypes.AllEntities,
        ''
      )
      .toPromise()
      .then(response => {
        this._vrsteZabrane = this.getResponseData(response);
        this.registerEnum(this._vrsteZabrane, 'MSSPO_VRZA_NazivEnum');
        this.registerEnum(this._vrsteZabrane, 'MSSPO_SPO_VrstaZabraneIdEnum');
      });
  }

  fetchTipoviPodugovora() {
    if (this.enumExists(this._tipoviPodugovora)) {
      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSUGO_TIP,
        FormName.MediaPlan,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._tipoviPodugovora = this.getResponseData(response);
        this.registerEnum(this._tipoviPodugovora, 'MSMP_MP_TipPodugovoraIdEnum');
      });
  }

  fetchTipoviUgovora() {
    if (this.enumExists(this._tipoviUgovora)) {
      this._tipoviUgovoraSubject.next(this._tipoviUgovora);

      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSUGO_TIP,
        FormName.TipUgovora,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._tipoviUgovora = this.getResponseData(response);
        this.registerEnum(this._tipoviUgovora, 'MSUGO_UGO_TipUgovoraIdEnum');
        this.registerEnum(this._tipoviUgovora, 'MSUGO_PUG_TipUgovoraIdEnum');
        this._tipoviUgovoraSubject.next(this._tipoviUgovora);
      });
  }

  fetchTipoviUgovoraSingle() {
    this._backendService
      .fetchSettings(
        FormCode.MSUGO_TIP,
        FormName.TipUgovora,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._tipoviUgovora = this.getResponseData(response);
        this.registerEnum(this._tipoviUgovora, 'MSUGO_UGOSINGLE_TipUgovoraIdEnum');
        this.registerEnum(this._tipoviUgovora, 'MSUGO_PUG_TipUgovoraIdEnum');
        this._tipoviUgovoraSubject.next(this._tipoviUgovora);
      });
  }

  fetchNacinObracunaUgovor(tipUgovoraId: any) {
    if (this.enumExists(this._naciniObracunaZaTipUgovora[tipUgovoraId])) {
      this.registerEnum(
        this._naciniObracunaZaTipUgovora[tipUgovoraId],
        'MSUGO_UGOSINGLE_NacinObracunaIdEnum'
      );

      this.tipUgovoraSwitched.next(tipUgovoraId);

      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSUGO_NOTU,
        FormName.SifarnikNacinaObracuna,
        EndpointTypes.AllEntities,
        `?TipUgovoraId=${tipUgovoraId}`
      )
      .toPromise()
      .then(response => {
        this._naciniObracunaZaTipUgovora[tipUgovoraId] = this.getResponseData(
          response
        );
        this.registerEnum(
          this._naciniObracunaZaTipUgovora[tipUgovoraId],
          'MSUGO_UGOSINGLE_NacinObracunaIdEnum'
        );

        this.tipUgovoraSwitched.next(tipUgovoraId);
      });
  }

  fetchAllNacinObracuna() {
    const enumName = 'MSUGO_PUGL_NacinObracunaIdEnum';
    if (this.enumExists(this._allNacinObracuna)) {
      this.registerEnum(this._allNacinObracuna, enumName);

      return;
    }
    this._backendService
      .fetchSettings(
        FormCode.MSUGO_NOTU,
        FormName.PregledSpotova,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(data => {
        const allNo = this.getResponseData(data);
        const set = Array.from(new Set(allNo.map(i => i.Id)));
        const list = [];
        set.forEach(element => {
          const no = allNo.find(o => o.Id === element);
          list.push(no);
        });

        this._allNacinObracuna = list;
        this.registerEnum(this._allNacinObracuna, enumName);
      });
  }

  fetchNacinObracunaPodugovor(tipUgovoraId: any) {
    if (this.enumExists(this._naciniObracunaZaTipUgovora[tipUgovoraId])) {
      this.registerEnum(
        this._naciniObracunaZaTipUgovora[tipUgovoraId],
        'MSUGO_PUG_NacinObracunaIdEnum'
      );
      this.tipUgovoraPugSwitched.next(tipUgovoraId);

      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSUGO_NOTU,
        FormName.SifarnikNacinaObracuna,
        EndpointTypes.AllEntities,
        `?TipUgovoraId=${tipUgovoraId}`
      )
      .toPromise()
      .then(response => {
        this._naciniObracunaZaTipUgovora[tipUgovoraId] = this.getResponseData(
          response
        );

        this.registerEnum(
          this._naciniObracunaZaTipUgovora[tipUgovoraId],
          'MSUGO_PUG_NacinObracunaIdEnum'
        );

        this.tipUgovoraPugSwitched.next(tipUgovoraId);
      });
  }

  fetchNacinPlacanja() {
    if (this.enumExists(this._naciniPlacanja)) {
      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSUGO_NP,
        FormName.SifarnikNacinaPlacanja,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._naciniPlacanja = this.getResponseData(response);
        this.registerEnum(
          this._naciniPlacanja,
          'MSUGO_UGOSINGLE_NacinPlacanjaIdEnum'
        );
        this.registerEnum(
          this._naciniPlacanja,
          'MSUGO_PUG_NacinPlacanjaIdEnum'
        );
      });
  }

  fetchVrstaUsluge() {
    if (this.enumExists(this._vrstaUsluge)) {
      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSUGO_VUS,
        FormName.VrstaUsluge,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._vrstaUsluge = this.getResponseData(response);
        this.registerEnum(this._vrstaUsluge, 'MSUGO_PUG_VrstaUslugeIdEnum');
      });
  }

  fetchStatusUgovora() {
    if (this.enumExists(this._statusiUgovora)) {
      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSUGO_STU,
        FormName.StatusUgovora,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._statusiUgovora = this.getResponseData(response);
        this.registerEnum(
          this._statusiUgovora,
          'MSUGO_UGO_StatusUgovoraIdEnum'
      )});
  }

  fetchStatusUgovoraSingle() {
    this._backendService
      .fetchSettings(
        FormCode.MSUGO_STU,
        FormName.StatusUgovora,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._statusiUgovora = this.getResponseData(response);
        this.registerEnum(
          this._statusiUgovora,
          'MSUGO_UGOSINGLE_StatusUgovoraIdEnum'
        );
        this.registerEnum(
          this._statusiUgovora,
          'MSUGO_PUG_StatusUgovoraIdEnum'
        );
        this._potpisanUgovorId = this.getUgovorIdByStatus('Potpisan');
        this._aneksiranUgovorId = this.getUgovorIdByStatus('Aneksiran');
      });
  }

  fetchValute() {
    if (this.enumExists(this._valuteUgo)) {
      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSKURS_VAL,
        FormName.PregledKursa,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        const valuteAll = this.getResponseData(response);

        this._valuteKurs = valuteAll.filter(x => x.Oznaka !== 'RSD');
        this._valuteUgo = valuteAll;
        // this._valuteUgo = valuteAll.filter(
        //   x => x.Oznaka === 'RSD' || x.Oznaka === 'EUR'
        // );

        this.registerEnum(
          this._valuteKurs,
          'MSKURS_KURS_ValutaIdEnum',
          'Oznaka'
        );
        this.registerEnum(this._valuteUgo, 'MSUGO_UGOSINGLE_ValutaIdEnum', 'Oznaka');
        this.registerEnum(this._valuteUgo, 'MSUGO_PUG_ValutaIdEnum', 'Oznaka');
        this.registerEnum(this._valuteUgo, 'ValutaIdEnum', 'Oznaka');

        this.registerEnum(
          this._valuteUgo,
          'MSUGO_BUKLI_ValutaIdEnum',
          'Oznaka'
        );
      });
  }

  fetchBanke(forceFetch: boolean = false) {
    if (this.enumExists(this._banke) && !forceFetch) {
      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSKURS_BNK,
        FormName.SifarnikBanaka,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._banke = this.getResponseData(response);
        this.registerEnum(this._banke, 'MSKURS_KURS_BankaIdEnum');
      });
  }

  fetchVrstaKlijenta() {
    if (this.enumExists(this._vrstaKlijenta)) {
      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSKLI_VRSKLI,
        FormName.PregledKlijenata,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._vrstaKlijenta = this.getResponseData(response);

        this.registerEnum(this._vrstaKlijenta, 'MSKLI_KLI_VrstaKlijentaEnum');
        this.registerEnum(
          this._vrstaKlijenta.filter(v => v.Id !== 3),
          'MSKLI_UGLKP_VrstaKlijentaEnum'
        );
      });
  }

  fetchProgrami() {
    if (this.enumExists(this._programi)) {
      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSPRO_PRO,
        FormName.PregledProgama,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._programi = this.getResponseData(response);

        this.registerEnum(this._programi, 'MSPRO_PRO_ProgramIdEnum');
        this.registerEnum(this._programi, 'MSEMI_EMI_ProgramIdEnum');
        this.registerEnum(this._programi, 'MSEMI_RAS_ProgramIdEnum');
        this.registerEnum(this._programi, 'ProgramEnumMediaPlan');
        this.registerEnum(this._programi, 'MSMP_REZ_ProgramIdEnum');
        this.registerEnum(this._programi, 'MSMP_POZ_ProgramIdEnum');
        this.registerEnum(this._programi, 'MSUGO_PUGCPO_ProgramIdEnum');
        this.registerEnum(this._programi, 'MSUGO_PUGCPP_ProgramIdEnum');
        this.registerEnum(this._programi, 'MSUGO_BRESPIC_ProgramIdEnum');
      });
  }

  fetchNacinEmitovanja() {
    if (this.enumExists(this._naciniEmitovanja)) {
      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSEMI_NAEM,
        FormName.PregledEmisija,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._naciniEmitovanja = this.getResponseData(response);

        this.registerEnum(
          this._naciniEmitovanja,
          'MSEMI_EMI_NacinEmitovanjaIdEnum'
        );
      });
  }

  fetchUcestalostEmitovanja() {
    if (this.enumExists(this._ucestalosti)) {
      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSEMI_MSEMI_UCEM,
        FormName.PregledEmisija,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._ucestalosti = this.getResponseData(response);
        this.registerEnum(
          this._ucestalosti,
          'MSEMI_EMI_UcestalostIdEnum',
          'Ucestalost'
        );
      });
  }

  fetchVrsteMedija() {
    if (this.enumExists(this._vrsteMedija)) {
      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSPRO_VRME,
        FormName.PregledProgama,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._vrsteMedija = this.getResponseData(response);
        this.registerEnum(this._vrsteMedija, 'MSMP_MP_VrstaMedijaIdEnum');
        this.registerEnum(this._vrsteMedija, 'MSPRO_PRO_VrstaMedijaIdEnum');
        this.registerEnum(this._vrsteMedija, 'MSSPO_SPO_VrstaMedijaIdEnum');
      });
  }

  fetchMestaTroska() {
    if (this.enumExists(this._mestaTroska)) {
      return;
    }

    this._backendService
      .fetchSettings(
        FormCode.MSPRO_METRO,
        FormName.PregledProgama,
        EndpointTypes.AllEntities
      )
      .toPromise()
      .then(response => {
        this._mestaTroska = this.getResponseData(response);
        this.registerEnum(this._mestaTroska, 'MSPRO_METRO_NazivEnum');
      });
  }

  registerMetodRacunanja() {
    const metodRacunanja = [
      {
        Id: 'Linearni',
        Naziv: 'Linearni',
      },
      {
        Id: 'Po koeficijentima',
        Naziv: 'Po koeficijentima',
      },
    ];

    this.registerEnum(metodRacunanja, 'MSUGO_PUG_MetodRacunanjaEnum');
  }

  getUgovorIdByStatus(status: string): Number {
    return this._statusiUgovora.find(d => d.Naziv === status).Id;
  }

  registerSpotFrameRates() {
    this.registerEnum(this._frameRates, 'SPOT_FRAME_RATES');
  }

  getDefaultFrameRate() {
    return this._frameRates[0].Id;
  }

  getProgramById(id) {
    return this.programi.find(p => p.Id === id);
  }

  getVrstaSpotaId(naziv: string) {
    return this._vrsteSpota.find(vs => vs.Naziv === naziv).Id;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/enum.service.ts